import { IMortgageBanksDataState } from '../../types/redux';

const defaultValue: IMortgageBanksDataState = {
  banksList: {
    mortgage: [],
    personalLoan: [],
  },
  rates: {
    new: 0,
    used: 0,
    apartments: 0,
    townhouse: 0,
  },
};

export function mortgageBanksDataReducer(state: IMortgageBanksDataState = defaultValue): IMortgageBanksDataState {
  return state;
}
